import styled from '@emotion/styled';
import { Content } from '../../src';

export const StyledContent = styled(Content)`
  padding: 2rem;
`;
